export type ReportItemDto = {
  id: string;
  name: string;
  createdAt: string | null;
  updatedAt: string | null;
  downloadUrl: string;
};

export type GetReportsResponseDto = {
  totalCount: number;
  items: ReportItemDto[];
};

export type GetReportsInProgress = {
  totalCount: number;
};

export enum ReportsFilterTypes {
  type = "type",
  status = "status",
}

export enum ReportsFilterNames {
  type = "Type",
  status = "Status",
}

export enum ReportType {
  ORDERS = "orders",
  TRANSACTIONS = "transactions",
  CUSTOMERS = "customers",
}

export enum ReportTypeLabel {
  orders = "Orders",
  transactions = "Transactions",
  customers = "Customers",
}

export enum ReportStatus {
  PENDING = "pending",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  FAILED = "failed",
}

export enum ReportStatusLabel {
  pending = "Pending",
  in_progress = "In progress",
  completed = "Completed",
  failed = "Failed",
}
